"use client";

import { useTranslations } from "next-intl";
import { InfiniteScroll } from "@/components/core/InfiniteScroll/InfiniteScroll";
import { useFetchMyPurchases } from "@/hooks/order/useFetchMyPurchases";
import { hasLoadedListItems } from "@/lib/pagination/hasLoadedListItems";
import {
  UserOrdersEmpty,
  UserOrdersProduct,
  UserOrdersProductSkeleton,
} from "./";

export const UserOrdersTab = () => {
  const t = useTranslations("orders");
  const orders = useFetchMyPurchases({ limit: 10 });

  if (orders.isLoading && !hasLoadedListItems(orders)) {
    return (
      <div className="w-full grid grid-cols-2 gap-4">
        {[1, 2, 3, 4].map((id) => (
          <UserOrdersProductSkeleton key={`skeleton-${id}`} />
        ))}
      </div>
    );
  }

  if (orders.error && !hasLoadedListItems(orders)) {
    return (
      <div className="w-full py-8">
        <div className="text-center text-semantic-error">
          <p>{t("error.loadOrders")}</p>
          <p className="text-sm mt-2">
            {orders.error &&
            typeof orders.error === "object" &&
            orders.error !== null &&
            "message" in orders.error
              ? String(orders.error.message)
              : t("error.unknown")}
          </p>
        </div>
      </div>
    );
  }

  const allOrders = orders.data?.pages.flatMap(
    (page) => page?.data?.result || [],
  );

  if (!allOrders || allOrders.length === 0) {
    return <UserOrdersEmpty description={t("empty.userEmpty")} />;
  }

  return (
    <div className="w-full grid grid-cols-2 gap-4">
      {allOrders.map((order) => (
        <UserOrdersProduct key={order.id} order={order} />
      ))}

      <InfiniteScroll query={orders} className="col-span-2 py-4" />
    </div>
  );
};
